import { render, staticRenderFns } from "./comp_CheckoutStep-payment--active.vue?vue&type=template&id=382e819e&scoped=true"
import script from "./comp_CheckoutStep-payment--active.vue?vue&type=script&lang=js"
export * from "./comp_CheckoutStep-payment--active.vue?vue&type=script&lang=js"
import style0 from "./comp_CheckoutStep-payment--active.vue?vue&type=style&index=0&id=382e819e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e819e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VIcon,VRadio,VRadioGroup})
